import { useUpdatePasswordCommand } from '@dreryk/egabinet-security-frontend';
import { commonTranslationKeys } from '@dreryk/react-common';
import {
   Button,
   ButtonVariant,
   dispatchSnackbarNegativeEvent,
   dispatchSnackbarPositiveEvent,
} from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../translations';

import { PASSWORD_UPDATE_FORM_INITIAL_VALUES } from './PasswordUpdateForm';
import { PasswordUpdateFormController } from './PasswordUpdateForm.types';

type PasswordUpdateSaveButtonProps = Pick<PasswordUpdateFormController, 'handleSubmit' | 'reset'>;

export const PasswordUpdateSaveButton = (props: PasswordUpdateSaveButtonProps): JSX.Element => {
   const { loading: changePasswordLoading, executeAsync: changePassword } = useUpdatePasswordCommand(
      () => {
         dispatchSnackbarPositiveEvent(personnelTranslationKeys.myAccount.password.passwordUpdated);
         props.reset(PASSWORD_UPDATE_FORM_INITIAL_VALUES);
      },
      () => {
         dispatchSnackbarNegativeEvent(personnelTranslationKeys.myAccount.password.incorrectOldPassword);
      }
   );

   return (
      <Button
         testId={'save'}
         label={commonTranslationKeys.save}
         disabled={changePasswordLoading}
         onClick={props.handleSubmit(
            async (data) =>
               // eslint-disable-next-line no-return-await
               await changePassword(data)
         )}
         variant={ButtonVariant.PRIMARY}
         blockingOperation
      />
   );
};
